import { graphql } from '~/__gql__';

export const mutationCreateAnalyticsEvent = graphql(/* GraphQL */ `
  mutation CreateAnalyticsEvent($input: AnalyticsEventInput!) {
    createAnalyticsEvent(input: $input, trackInLaunchDarkly: true)
  }
`);
